import type {ConferenceApiModel} from '../../../api/conference';
import type {
  CoreClientConferencesJoinParams,
  CoreCoachConferencesJoinParams,
} from '../../../api/types/core/methods';
import type {AsyncStrategy, BaseConfig} from '../utils';

import {conferenceStore} from '../../../api/conference';
import {isMeCoachForEntity} from '../../../utils/entity/isMeCoachForEntity';

export {conferenceJoin};

type Config = BaseConfig<
  Omit<CoreClientConferencesJoinParams | CoreCoachConferencesJoinParams, '_id'>
> & {
  entity: ConferenceApiModel;
};

const strategy: AsyncStrategy = async (roles, config) => {
  return isMeCoachForEntity((config as Config).entity)
    ? roles.coach(config)
    : roles.client(config);
};

async function conferenceJoin(config: Config) {
  return strategy({client: asClient, coach: asCoach}, config);
}

conferenceJoin.asClient = asClient;
conferenceJoin.asCoach = asCoach;

async function asClient({entity, params}: Config) {
  const result = await conferenceStore.client.join(entity, params);

  return result;
}

async function asCoach({entity, params}: Config) {
  const result = await conferenceStore.coach.join(entity, params);

  return result;
}
